import Vue from 'vue'
import VueHighcharts from 'vue-highcharts'
import io from 'socket.io-client'

import App from './App'
import router from './router'

import store from '@/store'
import { info } from '@/utils/api.js'
import bus from '@/utils/event_bus.js'
import { insertCustomCss } from '@/utils/index'
import i18n from '@/i18n'

import './style/dragon.less'

Vue.config.productionTip = false

Vue.use(VueHighcharts)

/* eslint-disable no-new */

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

info()
  .then((data) => {
    data = data.data
    store.commit('setInfo', data)
    // set default language en-us
    store.commit('setLocale', 'en-us')
    store.commit('setRouter', router)
    document.title = data.contest_name
    new Vue({
      el: '#app',
      store,
      router,
      render: h => h(App)
    })
    if (data.enable_websocket) {
      const socket = io()
      socket.on('UPDATE', (data) => {
        bus.$emit('UPDATE', data)
      })
    }
    insertCustomCss(data.custom_css)
  })

Object.assign(i18n.locales['en-us'], {
  about_: 'HOME',
  news_: 'NEWS',
  challenge_: 'CHALLENGE',
  rank_main_title_: 'Rank',
  trend_main_title_: 'Trend',
  news_main_title_: '',
  rank_table_: 'RANK',
  trend_: 'TREND'
})



// WEBPACK FOOTER //
// ./src/themes/dragon/main.js